document.addEventListener('DOMContentLoaded', function () {
    // Sadece sepet sayfasında çalışsın
    if (!document.body.classList.contains('template-cart')) return;

    const citySelect = document.getElementById('cart-city');
    const districtSelect = document.getElementById('cart-district');
    const postalInput = document.getElementById('cart-postal-code');
    const checkoutButton = document.querySelector('button[name="checkout"]');

    if (!citySelect || !districtSelect || !checkoutButton) return;

    // Butonun durumunu kontrol eden fonksiyon
    function checkCheckoutButton() {
        const city = citySelect.value;
        const district = districtSelect.value;

        
    }

    // Sayfa yüklendiğinde kontrol et
    checkCheckoutButton();

    // İl - ilçe - posta kodu verileri
    // Bunu ihtiyacına göre genişleteceksin
    const cityData = {
        "Adana": {
            "Aladağ": "01720",
            "Ceyhan": "01920",
            "Çukurova": "01060",
            "Feke": "01620",
            "İmamoğlu": "01740",
            "Karaisalı": "01120",
            "Karataş": "01960",
            "Kozan": "01520",
            "Pozantı": "01470",
            "Saimbeyli": "01640",
            "Sarıçam": "01220",
            "Seyhan": "01010",
            "Tufanbeyli": "01660",
            "Yumurtalık": "01680",
            "Yüreğir": "01240"
        },
        "Adıyaman": {
            "Besni": "02300",
            "Çelikhan": "02610",
            "Gerger": "02760",
            "Gölbaşı": "02800",
            "Kahta": "02400",
            "Merkez": "02100",
            "Samsat": "02840",
            "Sincik": "02930",
            "Tut": "02360"
        },
        "Afyonkarahisar": {
            "Başmakçı": "03450",
            "Bayat": "03720",
            "Bolvadin": "03300",
            "Çay": "03710",
            "Çobanlar": "03350",
            "Dazkırı": "03940",
            "Dinar": "03400",
            "Emirdağ": "03600",
            "Evciler": "03960",
            "Hocalar": "03540",
            "İhsaniye": "03370",
            "İscehisar": "03750",
            "Kızılören": "03560",
            "Merkez": "03030",
            "Sandıklı": "03500",
            "Sinanpaşa": "03850",
            "Sultandağı": "03380",
            "Şuhut": "03800"
        },
        "Ağrı": {
            "Diyadin": "04900",
            "Doğubayazıt": "04400",
            "Eleşkirt": "04600",
            "Hamur": "04850",
            "Merkez": "04100",
            "Patnos": "04500",
            "Taşlıçay": "04800",
            "Tutak": "04700"
        },
        "Aksaray": {
            "Ağaçören": "68800",
            "Eskil": "68820",
            "Gülağaç": "68520",
            "Güzelyurt": "68500",
            "Merkez": "68100",
            "Ortaköy": "68400",
            "Sarıyahşi": "68600",
            "Sultanhanı": "68190"
        },
        "Amasya": {
            "Göynücek": "05900",
            "Gümüşhacıköy": "05700",
            "Hamamözü": "05800",
            "Merkez": "05100",
            "Merzifon": "05300",
            "Suluova": "05500",
            "Taşova": "05850"
        },
        "Ankara": {
            "Akyurt": "06750",
            "Altındağ": "06230",
            "Ayaş": "06710",
            "Bala": "06720",
            "Beypazarı": "06730",
            "Çamlıdere": "06740",
            "Çankaya": "06690",
            "Çubuk": "06760",
            "Elmadağ": "06840",
            "Etimesgut": "06790",
            "Evren": "06850",
            "Gölbaşı": "06830",
            "Güdül": "06840",
            "Haymana": "06860",
            "Kahramankazan": "06980",
            "Kalecik": "06870",
            "Keçiören": "06290",
            "Kızılcahamam": "06890",
            "Mamak": "06260",
            "Nallıhan": "06920",
            "Polatlı": "06900",
            "Pursaklar": "06145",
            "Sincan": "06930",
            "Şereflikoçhisar": "06950",
            "Yenimahalle": "06170"
        },
        "Antalya": {
            "Akseki": "07630",
            "Aksu": "07100",
            "Alanya": "07400",
            "Demre": "07570",
            "Döşemealtı": "07190",
            "Elmalı": "07700",
            "Finike": "07740",
            "Gazipaşa": "07900",
            "Gündoğmuş": "07860",
            "İbradı": "07650",
            "Kaş": "07580",
            "Kemer": "07980",
            "Kepez": "07090",
            "Konyaaltı": "07070",
            "Korkuteli": "07880",
            "Kumluca": "07350",
            "Manavgat": "07600",
            "Muratpaşa": "07300",
            "Serik": "07500"
        },
        "Ardahan": {
            "Çıldır": "75400",
            "Damal": "75420",
            "Göle": "75700",
            "Hanak": "75300",
            "Merkez": "75100",
            "Posof": "75800"
        },
        "Artvin": {
            "Ardanuç": "08300",
            "Arhavi": "08200",
            "Borçka": "08400",
            "Hopa": "08600",
            "Kemalpaşa": "08700",
            "Merkez": "08000",
            "Murgul": "08500",
            "Şavşat": "08790",
            "Yusufeli": "08800"
        },
        "Aydın": {
            "Bozdoğan": "09760",
            "Buharkent": "09670",
            "Çine": "09500",
            "Didim": "09270",
            "Efeler": "09010",
            "Germencik": "09300",
            "İncirliova": "09600",
            "Karacasu": "09370",
            "Karpuzlu": "09570",
            "Koçarlı": "09960",
            "Kuşadası": "09400",
            "Kuyucak": "09930",
            "Nazilli": "09800",
            "Söke": "09200",
            "Sultanhisar": "09470",
            "Yenipazar": "09350",
            "Köşk": "09540"
        },
        "Balıkesir": {
            "Ayvalık": "10400",
            "Balya": "10840",
            "Bandırma": "10200",
            "Bigadiç": "10440",
            "Burhaniye": "10700",
            "Dursunbey": "10800",
            "Edremit": "10300",
            "Erdek": "10500",
            "Gömeç": "10710",
            "Gönen": "10900",
            "Havran": "10560",
            "İvrindi": "10860",
            "Karesi": "10100",
            "Kepsut": "10660",
            "Manyas": "10450",
            "Marmara": "10360",
            "Savaştepe": "10580",
            "Sındırgı": "10340",
            "Susurluk": "10600",
            "Altıeylül": "10020"
        },
        "Bartın": {
            "Amasra": "74300",
            "Kurucaşile": "74500",
            "Merkez": "74100",
            "Ulus": "74400"
        },
        "Batman": {
            "Beşiri": "72200",
            "Gercüş": "72300",
            "Hasankeyf": "72350",
            "Kozluk": "72400",
            "Merkez": "72060",
            "Sason": "72500"
        },
        "Bayburt": {
            "Aydıntepe": "69550",
            "Demirözü": "69400",
            "Merkez": "69000"
        },
        "Bilecik": {
            "Bozüyük": "11300",
            "Gölpazarı": "11700",
            "İnhisar": "11630",
            "Merkez": "11000",
            "Osmaneli": "11500",
            "Pazaryeri": "11800",
            "Söğüt": "11600",
            "Yenipazar": "11900"
        },
        "Bingöl": {
            "Adaklı": "12730",
            "Genç": "12500",
            "Karlıova": "12800",
            "Kiğı": "12850",
            "Merkez": "12000",
            "Solhan": "12700",
            "Yayladere": "12650",
            "Yedisu": "12670"
        },
        "Bitlis": {
            "Adilcevaz": "13700",
            "Ahlat": "13400",
            "Güroymak": "13800",
            "Hizan": "13600",
            "Merkez": "13000",
            "Mutki": "13750",
            "Tatvan": "13200"
        },
        "Bolu": {
            "Dörtdivan": "14900",
            "Gerede": "14900",
            "Göynük": "14730",
            "Kıbrıscık": "14620",
            "Mengen": "14840",
            "Merkez": "14030",
            "Mudurnu": "14800",
            "Seben": "14750",
            "Yeniçağa": "14650"
        },
        "Burdur": {
            "Ağlasun": "15830",
            "Altınyayla": "15470",
            "Bucak": "15300",
            "Çavdır": "15930",
            "Çeltikçi": "15120",
            "Gölhisar": "15400",
            "Karamanlı": "15650",
            "Kemer": "15530",
            "Merkez": "15030",
            "Tefenni": "15600",
            "Yeşilova": "15510"
        },
        "Bursa": {
            "Büyükorhan": "16980",
            "Gemlik": "16600",
            "Gürsu": "16580",
            "Harmancık": "16770",
            "İnegöl": "16400",
            "İznik": "16860",
            "Karacabey": "16700",
            "Keles": "16740",
            "Kestel": "16450",
            "Mudanya": "16940",
            "Mustafakemalpaşa": "16500",
            "Nilüfer": "16285",
            "Orhaneli": "16900",
            "Orhangazi": "16800",
            "Osmangazi": "16010",
            "Yenişehir": "16900",
            "Yıldırım": "16370"
        },
        "Çanakkale": {
            "Ayvacık": "17860",
            "Bayramiç": "17700",
            "Biga": "17200",
            "Bozcaada": "17680",
            "Çan": "17400",
            "Eceabat": "17900",
            "Ezine": "17600",
            "Gelibolu": "17500",
            "Gökçeada": "17760",
            "Lapseki": "17800",
            "Merkez": "17100",
            "Yenice": "17550"
        },
        "Çankırı": {
            "Atkaracalar": "18310",
            "Bayramören": "18330",
            "Çerkeş": "18600",
            "Eldivan": "18700",
            "Ilgaz": "18400",
            "Kızılırmak": "18250",
            "Korgun": "18270",
            "Kurşunlu": "18300",
            "Merkez": "18100",
            "Orta": "18800",
            "Şabanözü": "18650",
            "Yapraklı": "18900"
        },
        "Çorum": {
            "Alaca": "19600",
            "Bayat": "19850",
            "Boğazkale": "19330",
            "Dodurga": "19060",
            "İskilip": "19400",
            "Kargı": "19500",
            "Laçin": "19900",
            "Mecitözü": "19700",
            "Merkez": "19100",
            "Oğuzlar": "19450",
            "Ortaköy": "19570",
            "Osmancık": "19500",
            "Sungurlu": "19300",
            "Uğurludağ": "19350"
        },
        "Denizli": {
            "Acıpayam": "20800",
            "Babadağ": "20480",
            "Baklan": "20770",
            "Bekilli": "20930",
            "Beyağaç": "20590",
            "Bozkurt": "20350",
            "Buldan": "20400",
            "Çal": "20700",
            "Çameli": "20980",
            "Çardak": "20330",
            "Çivril": "20600",
            "Güney": "20260",
            "Honaz": "20330",
            "Kale": "20570",
            "Merkezefendi": "20040",
            "Pamukkale": "20160",
            "Sarayköy": "20300",
            "Serinhisar": "20430",
            "Tavas": "20500"
        },
        "Diyarbakır": {
            "Bağlar": "21090",
            "Bismil": "21500",
            "Çermik": "21600",
            "Çınar": "21750",
            "Çüngüş": "21800",
            "Dicle": "21830",
            "Eğil": "21950",
            "Ergani": "21900",
            "Hani": "21870",
            "Hazro": "21860",
            "Kayapınar": "21070",
            "Kocaköy": "21410",
            "Kulp": "21940",
            "Lice": "21720",
            "Merkez": "21050",
            "Silvan": "21640",
            "Sur": "21300",
            "Yenişehir": "21100"
        },
        "Düzce": {
            "Akçakoca": "81650",
            "Cumayeri": "81800",
            "Çilimli": "81030",
            "Gölyaka": "81810",
            "Gümüşova": "81850",
            "Kaynaşlı": "81950",
            "Merkez": "81010",
            "Yığılca": "81900"
        },
        "Edirne": {
            "Enez": "22750",
            "Havsa": "22530",
            "İpsala": "22490",
            "Keşan": "22800",
            "Lalapaşa": "22950",
            "Meriç": "22680",
            "Merkez": "22030",
            "Süloğlu": "22580",
            "Uzunköprü": "22200"
        },
        "Elazığ": {
            "Ağın": "23740",
            "Alacakaya": "23510",
            "Arıcak": "23520",
            "Baskil": "23800",
            "Karakoçan": "23700",
            "Keban": "23730",
            "Kovancılar": "23850",
            "Maden": "23400",
            "Merkez": "23100",
            "Palu": "23500",
            "Sivrice": "23600"
        },
        "Erzincan": {
            "Çayırlı": "24400",
            "İliç": "24700",
            "Kemah": "24450",
            "Kemaliye": "24610",
            "Merkez": "24100",
            "Otlukbeli": "24510",
            "Refahiye": "24300",
            "Tercan": "24860",
            "Üzümlü": "24150"
        },
        "Erzurum": {
            "Aşkale": "25500",
            "Aziziye": "25200",
            "Çat": "25650",
            "Hınıs": "25600",
            "Horasan": "25800",
            "İspir": "25900",
            "Karaçoban": "25610",
            "Karayazı": "25830",
            "Köprüköy": "25320",
            "Narman": "25530",
            "Oltu": "25400",
            "Olur": "25630",
            "Palandöken": "25050",
            "Pasinler": "25300",
            "Pazaryolu": "25930",
            "Şenkaya": "25550",
            "Tekman": "25560",
            "Tortum": "25430",
            "Uzundere": "25440",
            "Yakutiye": "25100"
        },
        "Eskişehir": {
            "Alpu": "26850",
            "Beylikova": "26750",
            "Çifteler": "26700",
            "Günyüzü": "26630",
            "Han": "26870",
            "İnönü": "26670",
            "Mahmudiye": "26900",
            "Mihalgazi": "26880",
            "Mihalıççık": "26950",
            "Odunpazarı": "26030",
            "Sarıcakaya": "26870",
            "Seyitgazi": "26950",
            "Sivrihisar": "26600",
            "Tepebaşı": "26040"
        },
        "Gaziantep": {
            "Araban": "27830",
            "İslahiye": "27800",
            "Karkamış": "27880",
            "Nizip": "27700",
            "Nurdağı": "27840",
            "Oğuzeli": "27900",
            "Şahinbey": "27110",
            "Şehitkamil": "27150",
            "Yavuzeli": "27810"
        },
        "Giresun": {
            "Alucra": "28700",
            "Bulancak": "28300",
            "Çamoluk": "28520",
            "Çanakçı": "28810",
            "Dereli": "28950",
            "Doğankent": "28510",
            "Espiye": "28600",
            "Eynesil": "28850",
            "Görele": "28800",
            "Güce": "28550",
            "Keşap": "28900",
            "Merkez": "28100",
            "Piraziz": "28340",
            "Şebinkarahisar": "28400",
            "Tirebolu": "28500",
            "Yağlıdere": "28610"
        },
        "Gümüşhane": {
            "Kelkit": "29600",
            "Köse": "29830",
            "Kürtün": "29840",
            "Merkez": "29100",
            "Şiran": "29700",
            "Torul": "29800"
        },
        "Hakkari": {
            "Çukurca": "30300",
            "Derecik": "30350",
            "Merkez": "30110",
            "Şemdinli": "30800",
            "Yüksekova": "30300"
        },
        "Hatay": {
            "Altınözü": "31750",
            "Antakya": "31040",
            "Arsuz": "31290",
            "Belen": "31350",
            "Defne": "31080",
            "Dörtyol": "31600",
            "Erzin": "31960",
            "Hassa": "31720",
            "İskenderun": "31200",
            "Kırıkhan": "31440",
            "Kumlu": "31850",
            "Payas": "31900",
            "Reyhanlı": "31500",
            "Samandağ": "31800",
            "Yayladağı": "31940"
        },
        "Iğdır": {
            "Aralık": "76400",
            "Karakoyunlu": "76600",
            "Merkez": "76000",
            "Tuzluca": "76700"
        },
        "Isparta": {
            "Aksu": "32500",
            "Atabey": "32670",
            "Eğirdir": "32800",
            "Gelendost": "32900",
            "Gönen": "32090",
            "Keçiborlu": "32700",
            "Merkez": "32100",
            "Senirkent": "32600",
            "Sütçüler": "32950",
            "Şarkikaraağaç": "32850",
            "Uluborlu": "32830",
            "Yalvaç": "32400",
            "Yenişarbademli": "32950"
        },
        "İstanbul": {
            "Adalar": "34970",
            "Arnavutköy": "34275",
            "Ataşehir": "34750",
            "Avcılar": "34310",
            "Bağcılar": "34200",
            "Bahçelievler": "34180",
            "Bakırköy": "34158",
            "Başakşehir": "34480",
            "Bayrampaşa": "34040",
            "Beşiktaş": "34353",
            "Beykoz": "34800",
            "Beylikdüzü": "34520",
            "Beyoğlu": "34430",
            "Büyükçekmece": "34500",
            "Çatalca": "34540",
            "Çekmeköy": "34782",
            "Esenler": "34235",
            "Esenyurt": "34510",
            "Eyüpsultan": "34065",
            "Fatih": "34080",
            "Gaziosmanpaşa": "34250",
            "Güngören": "34165",
            "Kadıköy": "34710",
            "Kağıthane": "34410",
            "Kartal": "34860",
            "Küçükçekmece": "34290",
            "Maltepe": "34840",
            "Pendik": "34890",
            "Sancaktepe": "34885",
            "Sarıyer": "34450",
            "Silivri": "34570",
            "Sultanbeyli": "34920",
            "Sultangazi": "34260",
            "Şile": "34980",
            "Şişli": "34360",
            "Tuzla": "34940",
            "Ümraniye": "34760",
            "Üsküdar": "34660",
            "Zeytinburnu": "34010"
        },
        "İzmir": {
            "Aliağa": "35800",
            "Balçova": "35330",
            "Bayındır": "35920",
            "Bayraklı": "35590",
            "Bergama": "35700",
            "Beydağ": "35740",
            "Bornova": "35040",
            "Buca": "35380",
            "Çeşme": "35930",
            "Çiğli": "35630",
            "Dikili": "35980",
            "Foça": "35680",
            "Gaziemir": "35410",
            "Güzelbahçe": "35310",
            "Karabağlar": "35170",
            "Karaburun": "35660",
            "Karakuyu": "35970",
            "Karşıyaka": "35580",
            "Kemalpaşa": "35730",
            "Kınık": "35990",
            "Kiraz": "35860",
            "Konak": "35250",
            "Menderes": "35470",
            "Menemen": "35660",
            "Narlıdere": "35320",
            "Ödemiş": "35750",
            "Seferihisar": "35460",
            "Selçuk": "35920",
            "Tire": "35900",
            "Torbalı": "35860",
            "Urla": "35430"
        },
        "Kahramanmaraş": {
            "Afşin": "46500",
            "Andırın": "46600",
            "Çağlayancerit": "46720",
            "Dulkadiroğlu": "46060",
            "Ekinözü": "46360",
            "Elbistan": "46300",
            "Göksun": "46650",
            "Nurhak": "46370",
            "Onikişubat": "46050",
            "Pazarcık": "46700",
            "Türkoğlu": "46800"
        },
        "Karabük": {
            "Eflani": "78300",
            "Eskipazar": "78400",
            "Merkez": "78100",
            "Ovacık": "78500",
            "Safranbolu": "78600",
            "Yenice": "78700"
        },
        "Karaman": {
            "Ayrancı": "70600",
            "Başyayla": "70750",
            "Ermenek": "70450",
            "Kazımkarabekir": "70650",
            "Merkez": "70100",
            "Sarıveliler": "70800"
        },
        "Kars": {
            "Akyaka": "36780",
            "Arpaçay": "36730",
            "Digor": "36670",
            "Kağızman": "36700",
            "Merkez": "36000",
            "Sarıkamış": "36500",
            "Selim": "36900",
            "Susuz": "36760"
        },
        "Kastamonu": {
            "Abana": "37970",
            "Ağlı": "37920",
            "Araç": "37800",
            "Azdavay": "37750",
            "Bozkurt": "37830",
            "Cide": "37600",
            "Çatalzeytin": "37940",
            "Daday": "37870",
            "Devrekani": "37700",
            "Doğanyurt": "37580",
            "Hanönü": "37300",
            "İhsangazi": "37250",
            "İnebolu": "37500",
            "Küre": "37900",
            "Merkez": "37100",
            "Pınarbaşı": "37400",
            "Seydiler": "37270",
            "Şenpazar": "37650",
            "Taşköprü": "37400",
            "Tosya": "37300"
        },
        "Kayseri": {
            "Akkışla": "38850",
            "Bünyan": "38600",
            "Develi": "38400",
            "Felahiye": "38750",
            "Hacılar": "38210",
            "İncesu": "38860",
            "Kocasinan": "38030",
            "Melikgazi": "38050",
            "Özvatan": "38770",
            "Pınarbaşı": "38700",
            "Sarıoğlan": "38820",
            "Sarız": "38650",
            "Talas": "38280",
            "Tomarza": "38900",
            "Yahyalı": "38500",
            "Yeşilhisar": "38800"
        },
        "Kilis": {
            "Elbeyli": "79500",
            "Merkez": "79000",
            "Musabeyli": "79600",
            "Polateli": "79700"
        },
        "Kırıkkale": {
            "Bahşılı": "71450",
            "Balışeyh": "71820",
            "Çelebi": "71870",
            "Delice": "71700",
            "Karakeçili": "71500",
            "Keskin": "71800",
            "Merkez": "71100",
            "Sulakyurt": "71850",
            "Yahşihan": "71420"
        },
        "Kırklareli": {
            "Babaeski": "39500",
            "Demirköy": "39680",
            "Kofçaz": "39700",
            "Lüleburgaz": "39750",
            "Merkez": "39100",
            "Pehlivanköy": "39620",
            "Pınarhisar": "39300",
            "Vize": "39400"
        },
        "Kırşehir": {
            "Akçakent": "40720",
            "Akpınar": "40320",
            "Boztepe": "40280",
            "Çiçekdağı": "40700",
            "Kaman": "40100",
            "Merkez": "40100",
            "Mucur": "40500"
        },
        "Kocaeli": {
            "Başiskele": "41090",
            "Çayırova": "41420",
            "Darıca": "41700",
            "Derince": "41900",
            "Dilovası": "41455",
            "Gebze": "41400",
            "Gölcük": "41650",
            "İzmit": "41040",
            "Kandıra": "41600",
            "Karamürsel": "41500",
            "Kartepe": "41080",
            "Körfez": "41780"
        },
        "Konya": {
            "Ahırlı": "42760",
            "Akören": "42460",
            "Akşehir": "42550",
            "Altınekin": "42340",
            "Beyşehir": "42700",
            "Bozkır": "42630",
            "Cihanbeyli": "42900",
            "Çeltik": "42940",
            "Çumra": "42500",
            "Derbent": "42930",
            "Derebucak": "42480",
            "Doğanhisar": "42950",
            "Emirgazi": "42440",
            "Ereğli": "42310",
            "Güneysınır": "42490",
            "Hadim": "42970",
            "Halkapınar": "42850",
            "Hüyük": "42690",
            "Ilgın": "42670",
            "Kadınhanı": "42830",
            "Karapınar": "42400",
            "Karatay": "42030",
            "Kulu": "42800",
            "Meram": "42040",
            "Sarayönü": "42430",
            "Selçuklu": "42060",
            "Seydişehir": "42370",
            "Taşkent": "42960",
            "Tuzlukçu": "42930",
            "Yunak": "42520",
            "Yalıhüyük": "42470"
        },
        "Kütahya": {
            "Altıntaş": "43800",
            "Aslanapa": "43210",
            "Çavdarhisar": "43710",
            "Domaniç": "43400",
            "Dumlupınar": "43510",
            "Emet": "43700",
            "Gediz": "43600",
            "Hisarcık": "43370",
            "Merkez": "43020",
            "Pazarlar": "43530",
            "Şaphane": "43950",
            "Simav": "43500",
            "Tavşanlı": "43300"
        },
        "Malatya": {
            "Akçadağ": "44600",
            "Arapgir": "44800",
            "Arguvan": "44960",
            "Battalgazi": "44090",
            "Darende": "44700",
            "Doğanyol": "44850",
            "Doğanşehir": "44500",
            "Hekimhan": "44400",
            "Kale": "44370",
            "Kuluncak": "44820",
            "Pütürge": "44850",
            "Yazıhan": "44950",
            "Yeşilyurt": "44070"
        },
        "Manisa": {
            "Ahmetli": "45450",
            "Akhisar": "45200",
            "Alaşehir": "45600",
            "Demirci": "45900",
            "Gölmarmara": "45500",
            "Gördes": "45700",
            "Kırkağaç": "45700",
            "Köprübaşı": "45940",
            "Kula": "45170",
            "Salihli": "45300",
            "Sarıgöl": "45470",
            "Saruhanlı": "45800",
            "Selendi": "45450",
            "Soma": "45500",
            "Şehzadeler": "45020",
            "Turgutlu": "45400",
            "Yunusemre": "45130"
        },
        "Mardin": {
            "Artuklu": "47200",
            "Dargeçit": "47750",
            "Derik": "47800",
            "Kızıltepe": "47300",
            "Mazıdağı": "47700",
            "Midyat": "47520",
            "Nusaybin": "47300",
            "Ömerli": "47570",
            "Savur": "47860",
            "Yeşilli": "47430"
        },
        "Mersin": {
            "Akdeniz": "33020",
            "Anamur": "33630",
            "Aydıncık": "33840",
            "Bozyazı": "33830",
            "Çamlıyayla": "33580",
            "Erdemli": "33730",
            "Gülnar": "33700",
            "Mezitli": "33330",
            "Mut": "33600",
            "Silifke": "33940",
            "Tarsus": "33400",
            "Toroslar": "33240",
            "Yenişehir": "33120"
        },
        "Muğla": {
            "Bodrum": "48400",
            "Dalaman": "48650",
            "Datça": "48900",
            "Fethiye": "48300",
            "Kavaklıdere": "48570",
            "Köyceğiz": "48800",
            "Marmaris": "48700",
            "Menteşe": "48000",
            "Milas": "48200",
            "Ortaca": "48600",
            "Seydikemer": "48850",
            "Ula": "48640",
            "Yatağan": "48500"
        },
        "Muş": {
            "Bulanık": "49500",
            "Hasköy": "49160",
            "Korkut": "49410",
            "Malazgirt": "49400",
            "Merkez": "49090",
            "Varto": "49600"
        },
        "Nevşehir": {
            "Acıgöl": "50170",
            "Avanos": "50500",
            "Derinkuyu": "50700",
            "Gülşehir": "50900",
            "Hacıbektaş": "50800",
            "Kozaklı": "50600",
            "Merkez": "50100",
            "Ürgüp": "50400"
        },
        "Niğde": {
            "Altunhisar": "51600",
            "Bor": "51700",
            "Çamardı": "51660",
            "Çiftlik": "51810",
            "Merkez": "51100",
            "Ulukışla": "51900"
        },
        "Ordu": {
            "Akkuş": "52950",
            "Aybastı": "52500",
            "Çamaş": "52750",
            "Çatalpınar": "52420",
            "Çaybaşı": "52350",
            "Fatsa": "52400",
            "Gölköy": "52600",
            "Gülyalı": "52010",
            "Gürgentepe": "52620",
            "İkizce": "52320",
            "Kabadüz": "52020",
            "Kabataş": "52520",
            "Korgan": "52700",
            "Kumru": "52850",
            "Mesudiye": "52900",
            "Perşembe": "52100",
            "Ulubey": "52800",
            "Ünye": "52300",
            "Altınordu": "52100"
        },
        "Osmaniye": {
            "Bahçe": "80500",
            "Düziçi": "80700",
            "Hasanbeyli": "80850",
            "Kadirli": "80760",
            "Merkez": "80010",
            "Sumbas": "80900",
            "Toprakkale": "80950"
        },
        "Rize": {
            "Ardeşen": "53400",
            "Çamlıhemşin": "53730",
            "Çayeli": "53200",
            "Derepazarı": "53950",
            "Fındıklı": "53500",
            "Güneysu": "53340",
            "Hemşin": "53590",
            "İkizdere": "53650",
            "İyidere": "53940",
            "Kalkandere": "53520",
            "Merkez": "53100",
            "Pazar": "53330"
        },
        "Sakarya": {
            "Adapazarı": "54050",
            "Akyazı": "54400",
            "Arifiye": "54580",
            "Erenler": "54200",
            "Ferizli": "54110",
            "Geyve": "54700",
            "Hendek": "54300",
            "Karapürçek": "54430",
            "Karasu": "54500",
            "Kaynarca": "54650",
            "Kocaali": "54800",
            "Pamukova": "54900",
            "Sapanca": "54600",
            "Serdivan": "54060",
            "Söğütlü": "54930",
            "Taraklı": "54750"
        },
        "Samsun": {
            "Alaçam": "55800",
            "Asarcık": "55840",
            "Atakum": "55200",
            "Ayvacık": "55550",
            "Bafra": "55400",
            "Canik": "55080",
            "Çarşamba": "55500",
            "Havza": "55700",
            "İlkadım": "55070",
            "Kavak": "55850",
            "Ladik": "55760",
            "Ondokuzmayıs": "55660",
            "Salıpazarı": "55630",
            "Tekkeköy": "55300",
            "Terme": "55600",
            "Vezirköprü": "55900",
            "Yakakent": "55810"
        },
        "Şanlıurfa": {
            "Akçakale": "63570",
            "Birecik": "63400",
            "Bozova": "63850",
            "Ceylanpınar": "63570",
            "Eyyübiye": "63050",
            "Halfeti": "63920",
            "Haliliye": "63090",
            "Harran": "63510",
            "Hilvan": "63900",
            "Karaköprü": "63140",
            "Siverek": "63600",
            "Suruç": "63800",
            "Viranşehir": "63820"
        },
        "Siirt": {
            "Baykan": "56460",
            "Eruh": "56800",
            "Kurtalan": "56700",
            "Merkez": "56100",
            "Pervari": "56780",
            "Şirvan": "56760",
            "Tillo": "56870"
        },
        "Sinop": {
            "Ayancık": "57400",
            "Boyabat": "57200",
            "Dikmen": "57660",
            "Durağan": "57700",
            "Erfelek": "57600",
            "Gerze": "57600",
            "Merkez": "57000",
            "Saraydüzü": "57230",
            "Türkeli": "57900"
        },
        "Şırnak": {
            "Beytüşşebap": "73800",
            "Cizre": "73200",
            "Güçlükonak": "73810",
            "İdil": "73300",
            "Merkez": "73000",
            "Silopi": "73400",
            "Uludere": "73600"
        },
        "Sivas": {
            "Akıncılar": "58550",
            "Altınyayla": "58470",
            "Divriği": "58300",
            "Doğanşar": "58780",
            "Gemerek": "58800",
            "Gölova": "58640",
            "Gürün": "58820",
            "Hafik": "58760",
            "İmranlı": "58980",
            "Kangal": "58900",
            "Koyulhisar": "58660",
            "Merkez": "58030",
            "Suşehri": "58600",
            "Şarkışla": "58400",
            "Ulaş": "58350",
            "Yıldızeli": "58550",
            "Zara": "58700"
        },
        "Tekirdağ": {
            "Çerkezköy": "59500",
            "Çorlu": "59850",
            "Ergene": "59930",
            "Hayrabolu": "59400",
            "Kapaklı": "59510",
            "Malkara": "59300",
            "Marmaraereğlisi": "59740",
            "Muratlı": "59700",
            "Saray": "59600",
            "Süleymanpaşa": "59030",
            "Şarköy": "59800"
        },
        "Tokat": {
            "Almus": "60900",
            "Artova": "60500",
            "Başçiftlik": "60620",
            "Erbaa": "60500",
            "Merkez": "60100",
            "Niksar": "60600",
            "Pazar": "60870",
            "Reşadiye": "60700",
            "Sulusaray": "60850",
            "Turhal": "60300",
            "Yeşilyurt": "60830",
            "Zile": "60400"
        },
        "Trabzon": {
            "Akçaabat": "61300",
            "Araklı": "61700",
            "Arsin": "61900",
            "Beşikdüzü": "61800",
            "Çarşıbaşı": "61420",
            "Çaykara": "61940",
            "Dernekpazarı": "61950",
            "Düzköy": "61390",
            "Hayrat": "61450",
            "Köprübaşı": "61640",
            "Maçka": "61750",
            "Of": "61620",
            "Ortahisar": "61100",
            "Şalpazarı": "61670",
            "Sürmene": "61600",
            "Tonya": "61500",
            "Vakfıkebir": "61400",
            "Yomra": "61200"
        },
        "Tunceli": {
            "Çemişgezek": "62600",
            "Hozat": "62400",
            "Mazgirt": "62800",
            "Merkez": "62000",
            "Nazımiye": "62150",
            "Ovacık": "62500",
            "Pertek": "62500",
            "Pülümür": "62700"
        },
        "Uşak": {
            "Banaz": "64500",
            "Eşme": "64600",
            "Karahallı": "64700",
            "Merkez": "64100",
            "Sivaslı": "64800",
            "Ulubey": "64900"
        },
        "Van": {
            "Bahçesaray": "65710",
            "Başkale": "65600",
            "Çaldıran": "65970",
            "Çatak": "65800",
            "Edremit": "65170",
            "Erciş": "65400",
            "Gevaş": "65700",
            "Gürpınar": "65900",
            "İpekyolu": "65140",
            "Muradiye": "65500",
            "Özalp": "65800",
            "Saray": "65760",
            "Tuşba": "65040"
        },
        "Yalova": {
            "Altınova": "77300",
            "Armutlu": "77500",
            "Çınarcık": "77320",
            "Çiftlikköy": "77600",
            "Merkez": "77100",
            "Termal": "77400"
        },
        "Yozgat": {
            "Akdağmadeni": "66700",
            "Aydıncık": "66520",
            "Boğazlıyan": "66400",
            "Çandır": "66500",
            "Çayıralan": "66600",
            "Çekerek": "66550",
            "Kadışehri": "66570",
            "Merkez": "66100",
            "Saraykent": "66320",
            "Sarıkaya": "66650",
            "Sefaatli": "Şefaatli",
            "Sorgun": "66600",
            "Şefaatli": "66800",
            "Yenifakılı": "66450",
            "Yerköy": "66900"
        },
        "Zonguldak": {
            "Alaplı": "67850",
            "Çaycuma": "67900",
            "Devrek": "67830",
            "Ereğli": "67300",
            "Gökçebey": "67670",
            "Kilimli": "67500",
            "Kozlu": "67600",
            "Merkez": "67000"
        }
    };

    function populateDistricts(city) {
        districtSelect.innerHTML = '<option value="">İlçe seçin</option>';

        if (!city || !cityData[city]) {
            districtSelect.disabled = true;
            postalInput.value = '';
            return;
        }

        Object.keys(cityData[city]).forEach(function (district) {
            const opt = document.createElement('option');
            opt.value = district;
            opt.textContent = district;
            districtSelect.appendChild(opt);
        });

        districtSelect.disabled = false;
    }

    citySelect.addEventListener('change', function () {
        populateDistricts(citySelect.value);
        postalInput.value = '';
        checkCheckoutButton(); // İl değişince butonu kontrol et
    });

    districtSelect.addEventListener('change', function () {
        const city = citySelect.value;
        const district = districtSelect.value;

        if (cityData[city] && cityData[city][district]) {
            postalInput.value = cityData[city][district];
        } else {
            postalInput.value = '';
        }
        checkCheckoutButton(); // İlçe değişince butonu kontrol et
    });

    // Checkout butonuna basıldığında:
    checkoutButton.addEventListener('click', function (e) {
        const city = (citySelect.value || '').trim();
        const district = (districtSelect.value || '').trim();
        const postal = (postalInput.value || '').trim();

     

        // Önce cart attributes içine yazalım
        e.preventDefault();

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                attributes: {
                    'İl': city,
                    'İlçe': district
                }
            })
        }).finally(function () {
            // Sonra checkout'a giderken var olan adres alanlarını doldur
            const params = new URLSearchParams({

                'checkout[shipping_address][city]': city,
                'checkout[shipping_address][address2]': district
            });

            window.location.href = '/checkout?' + params.toString();
        });
    });
});
